<template>
  <section id="businessAddress">
    <div class="container">
      <div class="header">
        <h5>Business</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#"  autocomplete="off">
        <h5>Great! Just a few more items...</h5>
        <div class="columns">
          <div class="column is-two-third">
            <div class="control">
              <label for="streetAddress">
                Street Address
                <span>*</span>
              </label>
              <input
                v-model="selectedAddress"
                v-validate="'required'"
                id="streetAddress"
                class="input"
                ref="autocomplete"
                type="text"
                placeholder="We want to find your nearest store"
                required
              >
            </div>
          </div>
        </div>
        <!-- <div class="columns">
          <div class="column is-one-third">
            <div class="question">
              <p>Would you like to apply for credit?</p>
              <small>We'll be in touch about the credit application process</small>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="content">
              <div class="titleContainer yesNo">
                <input type="radio" id="balanceYes" v-model="credit" value="yes">
                <label for="balanceYes">Yes Please</label>

                <input type="radio" id="balanceNo" v-model="credit" value="no">
                <label for="balanceNo">No Thanks</label>
              </div>
            </div>
          </div>
        </div> -->
        <div class="columns">
          <div class="column is-one-third">
            <div class="question m-0">
              <p>Would you like to hear about our great specials and promotions?</p>
              <small>We promise we won't spam you</small>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="content">
              <div class="titleContainer yesNo">
                <input type="radio" id="promotionYes" v-model="promotions" value="yes" :checked="promotions == 'yes'">
                <label for="promotionYes">Yes Please</label>

                <input :checked="promotions == 'no'" type="radio" id="promotionNo" v-model="promotions" value="no">
                <label for="promotionNo">No Thanks</label>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-two-thirds">
            <div class="termsAndConditions">
              <div class="checkBox">
                <input
                  v-validate="'required'"
                  type="checkbox"
                  name="TandC"
                  v-model="TandC"
                  id="TandC"
                >
                <span class="checkmark"></span>
              </div>
              <p>
                I agree to the
                <a @click="openTermsAndConditions">terms and conditions</a> specified.
              </p>
            </div>
          </div>
        </div>
      </form>

      <div class="actions">
        <button @click="back()" class="button is-white">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="toBusinessLoaylty()" class="button is-danger">Continue</button>
      </div>
    </div>
  </section>
</template>

<script>
import CancelButton from "../../components/actions/CancelButton";
import alertify from "alertifyjs";
export default {
  name: "businessaddress",
  data() {
    return {
      streetAddress: null,
      selectedAddress: null,
      TandC: null,
      credit: "yes",
      promotions: "yes"
    };
  },
  components: {
    CancelButton
  },
  methods: {
    toBusinessLoaylty() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
        } else {
          this.$gtag.event('promotions_newsletter', {
            'event_category': 'engagement',
            'event_label': this.promotions,
            'value': ''
          });
          this.$store.commit("SAVE_BUSINESS_ADDRESS", {
            address: this.selectedAddress,
            TandC: this.TandC,
            creditMail: this.credit,
            promotionMail: this.promotions
          });
          this.$router.push("/businessloyalty");
        }
      });
    },
    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    },
    openTermsAndConditions() {
      document.body.classList.add("showTermsAndConditions");
    }
  },
  mounted() {
    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      {
        types: ["geocode"]
      }
    );
    this.autocomplete.setComponentRestrictions({ country: ["za"] });

    this.autocomplete.addListener("place_changed", () => {
      let place = this.autocomplete.getPlace();
      this.selectedAddress = place.formatted_address;
    });

    this.selectedAddress = this.$store.state.business.address.selectedAddress
    this.TandC = this.$store.state.business.address.TandC
    this.credit = this.$store.state.business.address.credit
    
    if(this.$store.state.business.address.promotions){
      this.promotions = this.$store.state.business.address.promotions
    }
  }
};
</script>